// extracted by mini-css-extract-plugin
export var dateLabel = "_3p-0";
export var dateLabelError = "_3p-1";
export var fullWidth = "_3p-2";
export var smaller = "_3p-3";